import { useState } from "react";
import { ROOM_TYPE_LABEL, SIDE_ROOM_TYPES, type RoomType } from "@umzugsscan/shared";
import { useDraft, useStore } from "../hooks.ts";
import { useNav } from "../Erfassung.tsx";
import { Button, Dialog, Footer, Stepper } from "../ui/elemente.tsx";
import { DEFAULT_COUNTS, reconcileRooms, roomCounts } from "../zustand.ts";

const MAIN: RoomType[] = ["flur", "wohnen", "schlafen", "kind", "arbeit", "esszimmer", "kueche", "bad", "abstellraum", "sonstiges"];

export function Raeume() {
  const d = useDraft();
  const store = useStore();
  const { weiter, zurueck } = useNav();
  const [counts, setCounts] = useState<Partial<Record<RoomType, number>>>(() =>
    d.rooms.length > 0 ? roomCounts(d.rooms) : { ...DEFAULT_COUNTS },
  );
  const [confirmRemove, setConfirmRemove] = useState<string[] | null>(null);
  const total = Object.values(counts).reduce((a, b) => a + (b ?? 0), 0);

  const apply = () => {
    store.setRoomCounts(counts);
    weiter();
  };
  const next = () => {
    // Räume mit Fotos nur nach Rückfrage entfernen.
    const { remove } = reconcileRooms(d.rooms, counts, () => "");
    const withPhotos = remove.filter((r) => d.photos.some((p) => p.roomId === r.id)).map((r) => r.name);
    if (withPhotos.length > 0) setConfirmRemove(withPhotos);
    else apply();
  };

  const stepper = (t: RoomType) => (
    <Stepper key={t} label={ROOM_TYPE_LABEL[t]} value={counts[t] ?? 0} onChange={(v) => setCounts({ ...counts, [t]: v })} />
  );

  return (
    <>
      <h1>Welche Räume hat Ihre jetzige Wohnung?</h1>
      <p className="lead">Bitte alle Räume angeben, aus denen etwas mitkommt.</p>
      <section className="card">{MAIN.map(stepper)}</section>
      <h2>Nebenräume</h2>
      <p className="hint">Auch Keller, Dachboden, Garage und Balkon gehören dazu, wenn dort etwas steht.</p>
      <section className="card">{SIDE_ROOM_TYPES.map(stepper)}</section>
      <Footer onBack={zurueck} onNext={next} nextDisabled={total === 0} />

      {confirmRemove && (
        <Dialog
          title="Räume mit Fotos entfernen?"
          onClose={() => setConfirmRemove(null)}
          actions={
            <>
              <Button variant="danger" onClick={apply}>
                Ja, entfernen
              </Button>
              <Button variant="quiet" onClick={() => setConfirmRemove(null)}>
                Abbrechen
              </Button>
            </>
          }
        >
          <p>Für {confirmRemove.join(", ")} gibt es schon Fotos. Diese werden mit gelöscht.</p>
        </Dialog>
      )}
    </>
  );
}
